import { alpha } from '@mui/material/styles';

import type { Theme } from '@mui/material/styles';

export type GradientDirection =
  | 'to top'
  | 'to bottom'
  | 'to left'
  | 'to right'
  | 'right'
  | 'left'
  | 'up'
  | 'down'
  | 'top'
  | 'bottom'
  | `${number}deg`;

interface BackgroundBlurProps {
  blur?: number;
  opacity?: number;
  color?: string;
}

interface BackgroundGradientProps {
  direction?: string;
  startColor?: string;
  endColor?: string;
}

interface BackgroundImageProps extends BackgroundGradientProps {
  url?: string;
}

const getDirection = (value = 'bottom'): string | undefined => ({
  top: 'to top',
  right: 'to right',
  bottom: 'to bottom',
  left: 'to left',
}[value]);

type CssStyleHelper = {
  bgBlur: (props?: BackgroundBlurProps) => {
    WebkitBackdropFilter: string;
    backgroundColor: string;
    backdropFilter: string;
  };
  bgImage: (props?: BackgroundImageProps) => {
    background: string;
    backgroundSize: string;
    backgroundPosition: string;
    backgroundRepeat: string;
  };
  bgGradient: (props?: BackgroundGradientProps) => { background: string };
};

export const cssStyles = (theme?: Theme): CssStyleHelper => ({
  bgBlur: (props?: BackgroundBlurProps) => {
    const color = props?.color || theme?.palette.background.default || '#000000';

    const blur = props?.blur || 6;
    const opacity = props?.opacity || 0.8;

    return {
      backdropFilter: `blur(${blur}px)`,
      WebkitBackdropFilter: `blur(${blur}px)`, // Fix on Mobile
      backgroundColor: alpha( color, opacity ),
    };
  },
  bgGradient: (props?: BackgroundGradientProps) => {
    const direction = getDirection( props?.direction );
    const startColor = props?.startColor || `${alpha( '#000000', 0 )} 0%`;
    const endColor = props?.endColor || '#000000 75%';

    return {
      background: `linear-gradient(${direction}, ${startColor}, ${endColor});`,
    };
  },
  bgImage: (props?: BackgroundImageProps) => {
    const url = props?.url || 'https://zone-assets-api.vercel.app/assets/bg_gradient.jpg';
    const direction = getDirection( props?.direction );
    const startColor = props?.startColor || alpha( theme?.palette.grey[900] || '#000000', 0.88 );
    const endColor = props?.endColor || alpha( theme?.palette.grey[900] || '#000000', 0.88 );

    return {
      background: `linear-gradient(${direction}, ${startColor}, ${endColor}), url(${url})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center center',
    };
  },
});
